import { Observable } from 'rxjs-compat/Observable';
import { Subject } from 'rxjs-compat/Subject';

/**
 * Append a javascript resource at the end of the body
 * @param document the document
 * @param src resource src
 * @returns Observer<boolean>
 */
function loadScriptResource(document, src: string): Observable<boolean> {
    const loaded$ = new Subject<boolean>();
    const scriptElement = document.createElement('script');
    // Listen for the script to be loaded
    scriptElement.onload = () => {
        loaded$.complete();
    };
    scriptElement.src = src;
    scriptElement.type = 'text/javascript';
    document.body.appendChild(scriptElement);

    return loaded$.asObservable();
}

export default loadScriptResource;
